import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["starredCheckbox", "alertWindowContainer", "alertWindow"]

  toggleAlertWindow() {
    const isChecked = this.starredCheckboxTarget.checked
    this.alertWindowContainerTarget.classList.toggle("hidden", !isChecked)
  }

  // Takes the suggestion in one click. Still needs Save, so it reads as filling the field in
  // rather than as an action of its own.
  applySuggestion(event) {
    this.alertWindowTarget.value = event.currentTarget.dataset.windowHours
  }
}
